export const superAdminMenuLists = [
  {
    title: 'Home',
    path: '/home',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Search',
    path: '/search',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Inventory',
    path: '/inventory',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Report',
    path: '/report/',
    icon: '',
    subMenu: true,
    menu: [
      {
        title: 'vehicle utilization',
        path: '/report/vehicle-utilization',
        icon: '',
      },
      {
        title: 'venus utilization',
        path: '/report/venus-utilization',
        icon: '',
      },
      {
        title: 'weapons utilizations',
        path: '/report/weapons-utilization',
        icon: '',
      },
    ],
  },
  {
    title: 'User',
    path: '/user/',
    icon: '',
    subMenu: true,
    menu: [
      {
        title: 'Manage User Details',
        path: '/user/user-details',
        icon: '',
      },
      {
        title: 'Resources User Details',
        path: '/user/resources-list',
        icon: '',
      },
    ],
  },
  {
    title: 'Admin',
    path: '/admin/',
    icon: '',
    subMenu: true,
    menu: [
      {
        title: 'Manage User',
        path: '/admin/manage-user',
        icon: '',
      },
      {
        title: 'Resources',
        path: '/admin/resources',
        icon: '',
      },
    ],
  },
  {
    title: 'About',
    path: '/about',
    icon: '',
    subMenu: false,
    menu: [],
  },
];
export const adminMenuLists = [
  {
    title: 'Home',
    path: '/home',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Search',
    path: '/search',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Inventory',
    path: '/inventory',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Report',
    path: '/report/',
    icon: '',
    subMenu: true,
    menu: [
      {
        title: 'vehicle utilization',
        path: '/report/vehicle-utilization',
        icon: '',
      },
      {
        title: 'venus utilization',
        path: '/report/venus-utilization',
        icon: '',
      },
      {
        title: 'weapons utilizations',
        path: '/report/weapons-utilization',
        icon: '',
      },
    ],
  },
  {
    title: 'About',
    path: '/about',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Admin',
    path: '/admin/',
    icon: '',
    subMenu: true,
    menu: [
      {
        title: 'Manage User',
        path: '/admin/manage-user',
        icon: '',
      },
      {
        title: 'Resources',
        path: '/admin/resources',
        icon: '',
      },
    ],
  },
];
export const userMenuLists = [
  {
    title: 'Home',
    path: '/home',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Search',
    path: '/search',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Inventory',
    path: '/inventory',
    icon: '',
    subMenu: false,
    menu: [],
  },
  {
    title: 'Report',
    path: '/report/',
    icon: '',
    subMenu: true,
    menu: [
      {
        title: 'vehicle utilization',
        path: '/report/vehicle-utilization',
        icon: '',
      },
      {
        title: 'venus utilization',
        path: '/report/venus-utilization',
        icon: '',
      },
      {
        title: 'weapons utilizations',
        path: '/report/weapons-utilization',
        icon: '',
      },
    ],
  },
  {
    title: 'User',
    path: '/user/',
    icon: '',
    subMenu: true,
    menu: [
      {
        title: 'Manage User Details',
        path: '/user/user-details',
        icon: '',
      },
      {
        title: 'Resources User Details',
        path: '/user/resources-list',
        icon: '',
      },
    ],
  },
  {
    title: 'About',
    path: '/about',
    icon: '',
    subMenu: false,
    menu: [],
  },
];
